import styled from "styled-components";
import Select from "react-select";

const DEFAULT_COLORS = ["#1E22FF", "#6366FF", "#9194FF", "#AEB0FF", "#D2D3FF"];

const renderChannelColor = (theme, selectedChannel, currentChannel, index) => {
  const channelIsSelected = currentChannel === selectedChannel;

  if (!selectedChannel) {
    return DEFAULT_COLORS[index % DEFAULT_COLORS.length];
  }

  if (selectedChannel && !channelIsSelected) {
    return theme.colors.dataViz.secondaryBoxIconBackground;
  }

  if (channelIsSelected) {
    return DEFAULT_COLORS[0];
  }
};

const renderChannelOptionBgColor = (theme, selectedChannel, currentChannel) => {
  const channelIsSelected = currentChannel === selectedChannel;

  if (channelIsSelected) {
    return "transparent";
  }

  return theme.colors.dataViz.channelOptionBackgroundColor;
};

export const ChannelIcon = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 11px;
  background-color: ${({ theme, selectedChannel, currentChannel }) =>
    renderChannelOptionBgColor(theme, selectedChannel, currentChannel)};
  border: 1px solid ${({ theme }) => theme.colors.dataViz.channelOptionBorderColor};
  border-radius: 5px;
  transition: border 0.4s ease-in-out;
  white-space: nowrap;

  &:hover {
    border: 1px solid
      ${({ theme, selectedChannel, currentChannel, index }) =>
        renderChannelColor(theme, selectedChannel, currentChannel, index)};
  }
`;

export const ChannelDot = styled.div`
  display: ${({ hideChannelDot }) => (hideChannelDot ? "none" : "flex")};
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${({ theme, selectedChannel, currentChannel, index }) =>
    renderChannelColor(theme, selectedChannel, currentChannel, index)};
`;

export const ControlReactSelect = {
  control: (baseStyles) => ({
    ...baseStyles,
    height: "40x",
    border: "1px solid var(--primary-dark-200)",
    cursor: "pointer"
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    fontWeight: 400,
    cursor: "pointer",
    backgroundColor: isSelected ? "#4382f7" : "white",
    ":hover": {
      backgroundColor: isSelected ? "#4382f7" : "#deebff"
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--primary-dark)",
    padding: "1px 0"
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "var(--primary-dark-200)",
    "&:hover": {
      color: "var(--primary-dark-200)"
    }
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "var(--primary-dark-200)",
    "&:hover": {
      backgroundColor: "var(--primary-dark-200)"
    }
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "var(--primary-dark-200)",
    "&:hover": {
      color: "var(--primary-dark-200)"
    }
  })
};

export const ChannelList = styled(Select)`
  color: blue;
  width: 200px;
  text-transform: capitalize;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const Options = styled.div`
  display: flex;
  gap: ${({ isStringOptions }) => (isStringOptions ? "35px" : "10px")};
  cursor: pointer;
  min-width: fit-content;
`;

export const OptionsChannels = styled.div`
  font-size: 11px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.dataViz.primaryMetricTitleColor};
`;

export const StringOption = styled.div`
  font-size: ${({ isSelected }) => (isSelected ? "12px" : "11px")};
  text-transform: capitalize;
  font-weight: ${({ isSelected }) => (isSelected ? "600" : "400")};
  color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colors.dataViz.selectedMetricTitleColor
      : theme.colors.dataViz.primaryMetricTitleColor};

  transition: all 0.3s ease-in-out;
`;
